/**
 * @generated SignedSource<<664acbfa75566680b2d2f4cfe5c037bf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type IntegrationTomraScreenRvmsQuery$variables = Record<PropertyKey, never>;
export type IntegrationTomraScreenRvmsQuery$data = {
  readonly store: {
    readonly integrationTomra: {
      readonly rvms: ReadonlyArray<{
        readonly id: string | null;
        readonly name: string | null;
        readonly " $fragmentSpreads": FragmentRefs<"IntegrationTomraScreen_RvmFragment">;
      }> | null;
    } | null;
  };
};
export type IntegrationTomraScreenRvmsQuery = {
  response: IntegrationTomraScreenRvmsQuery$data;
  variables: IntegrationTomraScreenRvmsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "IntegrationTomraScreenRvmsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "IntegrationTomra",
            "kind": "LinkedField",
            "name": "integrationTomra",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "IntegrationTomraRVM",
                "kind": "LinkedField",
                "name": "rvms",
                "plural": true,
                "selections": [
                  (v0/*: any*/),
                  (v1/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "IntegrationTomraScreen_RvmFragment"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "IntegrationTomraScreenRvmsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "IntegrationTomra",
            "kind": "LinkedField",
            "name": "integrationTomra",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "IntegrationTomraRVM",
                "kind": "LinkedField",
                "name": "rvms",
                "plural": true,
                "selections": [
                  (v0/*: any*/),
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "serialNumber",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v0/*: any*/)
            ],
            "storageKey": null
          },
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b16e699e0402e0dcd4a588a7eb7cb258",
    "id": null,
    "metadata": {},
    "name": "IntegrationTomraScreenRvmsQuery",
    "operationKind": "query",
    "text": "query IntegrationTomraScreenRvmsQuery {\n  store {\n    integrationTomra {\n      rvms {\n        id\n        name\n        ...IntegrationTomraScreen_RvmFragment\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment IntegrationTomraScreen_RvmFragment on IntegrationTomraRVM {\n  id\n  serialNumber\n  name\n}\n"
  }
};
})();

(node as any).hash = "a5a104491bee8bce6d14609488e725b4";

export default node;
